declare global {
  interface Window {
    env: any;
  }
}

export enum EnvironmentValue {
  Dev = 'DEVELOPMENT',
  Test = 'TEST',
  Prod = 'PRODUCTION',
}

// change with your own variables
type EnvType = {
  REACT_APP_API_URL: string;
  REACT_APP_OKTA_ISSUER: string;
  REACT_APP_OKTA_CLIENT_ID: string;
  REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY: string;
  REACT_APP_OKTA_REDIRECT_URI: string;
  REACT_APP_HELLO_SIGN_CLIENT_ID: string;
  REACT_APP_ENVIRONMENT: EnvironmentValue;
  REACT_APP_V1_PORTAL_URL: string;
  REACT_APP_BASE_URL: string;
  REACT_APP_DIGIFI_ENVIRONMENT: string;
  REACT_APP_PRIVACY_POLICY_URL: string;
  REACT_APP_REPUBLIC_FINANCE_PREQUAL_URL: string;
  REACT_APP_TERMS_OF_USE_URL: string;
  PUBLIC_URL: string;
  REACT_APP_REPUBLIC_FINANCE_HOME_PAGE: string;
  REACT_APP_REPUBLIC_FINANCE_EMAIL: string;
  REACT_APP_REPUBLIC_FINANCE_ACCOUNT_PAGE: string;
  REACT_APP_REPUBLIC_FINANCE_APP_STORE_LINK: string;
  REACT_APP_REPUBLIC_FINANCE_GOOGLE_PLAY_LINK: string;
};
export const env: EnvType = { ...process.env, ...window.env };
